import { IOfferCard } from '../../../types';

export const isAgent = ({ user }: IOfferCard) => user && user.isAuthenticated && !!user.isAgent;
